<mat-card class="contact-card" data-cy="contact-card">
<mat-card-header class="tw-items-center tw-px-3">
    <h2 class="mb-0" data-cy="contact-card-name">
      <span>{{ contact.first }} {{ contact.last }}</span>
      <span class="tw-ml-1">({{contact.percentOwnership}}%)</span>
    </h2>
    <div class="contact-checkboxes">
      <!-- <mat-checkbox
        class="is-business-checkbox"
        (change)="toggleIsBusiness()"
        [checked]="isBusiness">
        Is a Business
      </mat-checkbox> -->
      <mat-checkbox
        data-cy="edit-contact-dialog-is-primary-checkbox"
        (change)="toggleIsPrimaryContact()"
        [checked]="!!(contact.isPrimary)"
        [disabled]="!!(contact.isPrimary)">
        Primary Contact
      </mat-checkbox>
    </div>
  </mat-card-header>
  <mat-card-content>
    <form [formGroup]="form">
      <formly-form
        [form]="form"
        [fields]="fields"
        [model]="model"
        [options]="options">
      </formly-form>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div *ngIf="contact.id && !contact.isPrimary" class="contact-delete-buttons">
      <button
        data-cy="edit-contact-dialog-delete-button"
        color="warn"
        class="contact-delete-button"
        [disabled]="saving.saving"
        mat-flat-button
        *ngIf="!confirmDelete"
        (click)="confirmDelete = !confirmDelete">
        <mat-icon>delete_outline</mat-icon>
      </button>
      <button
        data-cy="edit-contact-dialog-cancel-delete-button"
        mat-button
        *ngIf="confirmDelete"
        (click)="confirmDelete = !confirmDelete">
        Cancel
      </button>
      <button
        data-cy="edit-contact-dialog-confirm-delete-button"
        [disabled]="saving.saving"
        mat-flat-button
        color="warn"
        *ngIf="confirmDelete"
        (click)="delete()">
        Confirm
      </button>
    </div>
    <div class="contact-edit-buttons">
      <button
        *ngIf="form.dirty && !saving.saving"
        mat-button
        (click)="cancelEdit()"
        class="contact-cancel-edit"
        [disabled]="saving.saving">
        Cancel
      </button>
      <button
        data-cy="save-button"
        mat-flat-button
        color="primary"
        (click)="save()"
        [disabled]="!form.dirty || !form.valid || saving.saving">
        <mat-spinner
          *ngIf="showLoadingSpinner()"
          diameter="24"
          class="contact-spinny-spinner">
        </mat-spinner>
        <span *ngIf="showSaveText()">
          Save
        </span>
      </button>
    </div>
  </mat-card-actions>
  <!-- Signature Request -->
  <app-signature-request-smart
    *ngIf="contact.id"
    [contact]="contact">
  </app-signature-request-smart>
</mat-card>
